// src/components/AccessHistory.js

import React, { useEffect, useState } from 'react';
import { Modal, Nav, Tab } from 'react-bootstrap';
import axios from 'helpers/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop } from '@fortawesome/free-solid-svg-icons';
import { faAndroid, faApple } from '@fortawesome/free-brands-svg-icons';
import moment from 'moment';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import LoginHistoryTab from './LoginHistoryTab';
import UserActiveSessionsTab from './UserActiveSessionsTab';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import ActivityStats from 'components/navbar/userprofile/ActivityStats';
// import LoginSourceBadge from 'components/common/LoginSourceBadge';

const AccessHistory = ({ show, onHide, userId, username }) => {
  const [activityData, setActivityData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && userId) fetchData();
  }, [show, userId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('accessToken');
      const headers = { Authorization: `Bearer ${token}` };
      const base = `${process.env.REACT_APP_SERVER_URL}/users/activity-log/${userId}`;

      const loginRes = await axios.get(base, { headers });

      setActivityData(loginRes.data.data ?? []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-9">
          Access History
          {username && (
            <span className="text-muted fw-normal ms-2 fs-10">— {username}</span>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-3"
        style={{ height: '560px', overflowY: 'auto' }}>
        {loading ? (
          <ShimmerUI></ShimmerUI>
        ) : (
          <Tab.Container defaultActiveKey="login">
            <Nav variant="tabs" className="mb-3">
              <Nav.Item>
                <Nav.Link eventKey="login">
                  <FontAwesomeIcon icon="list-alt" className="me-1" />
                  Active Sessions
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="activity">
                  <FontAwesomeIcon icon="sign-in-alt" className="me-1" />
                  Activity Log
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="stats">
                  <FontAwesomeIcon icon="sign-in-alt" className="me-1" />
                  Activity Stats
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="login">
                <UserActiveSessionsTab userId={userId} />
              </Tab.Pane>
              <Tab.Pane eventKey="activity">
                <LoginHistoryTab data={activityData} />
              </Tab.Pane>
              <Tab.Pane eventKey="stats">
                <ActivityStats userId={userId} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AccessHistory;
